module.exports = __webpack_public_path__ + "assets/img/chart_keshi_head_icon.cc662b45.svg";